import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';
import { EmptyState, ErrorState, LoadingState } from '../../components/ui/state';
import { api } from '../../shared/api';

export interface PublicPhoto {
  readonly id: string;
  readonly downloadUrl: string;
  readonly fileName: string;
}

export function PublicStayGalleryPage() {
  const { shortId = '' } = useParams();
  const galleryQuery = useQuery({ queryKey: ['public-gallery', shortId], queryFn: () => api.publicGallery(shortId), enabled: Boolean(shortId) });
  return <PublicGallery isLoading={galleryQuery.isLoading} error={galleryQuery.error} label={galleryQuery.data ? `Galería #${galleryQuery.data.shortId}` : 'Galería'} photos={galleryQuery.data?.photos ?? []} />;
}

export function PublicDaycareGalleryPage() {
  const { daycareId = '' } = useParams();
  const galleryQuery = useQuery({ queryKey: ['public-daycare-gallery', daycareId], queryFn: () => api.publicDaycareGallery(daycareId), enabled: Boolean(daycareId) });
  return <PublicGallery isLoading={galleryQuery.isLoading} error={galleryQuery.error} label="Galería de guardería" photos={galleryQuery.data?.photos ?? []} />;
}

export function PublicGallery({ isLoading, error, label, photos }: { readonly isLoading: boolean; readonly error: Error | null; readonly label: string; readonly photos: PublicPhoto[] }) {
  if (isLoading) return <main className="min-h-screen bg-[#f8faf6] p-5"><LoadingState label="Cargando fotos" /></main>;
  if (error) return <main className="min-h-screen bg-[#f8faf6] p-5"><ErrorState message={error.message} /></main>;
  return (
    <main className="min-h-screen bg-[#f8faf6] px-5 py-8 text-[#223126]">
      <div className="mx-auto max-w-6xl space-y-6">
        <div><h1 className="text-3xl font-semibold">Fotos de Happy Bark</h1><p className="mt-1 text-sm text-[#687461]">{label}</p></div>
        {photos.length === 0 ? <EmptyState title="Aún no hay fotos" body="El equipo agregará fotos durante la visita." /> : null}
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {photos.map((photo) => (
            <div key={photo.id} className="overflow-hidden rounded-lg border border-[#d9dfd1] bg-white shadow-sm">
              <img src={photo.downloadUrl} alt={photo.fileName} className="aspect-square w-full object-cover" />
              <div className="p-3 text-sm font-medium">{photo.fileName}</div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
